import { platformizedFilterBuilder } from '../filter';
import { wixDataEncoder } from '@wix/filter-builder';
export function filterBuilder(opts) {
    return platformizedFilterBuilder({
        ...opts,
        encoder: wixDataEncoder,
        validateCollectionName: false,
    });
}
//# sourceMappingURL=common.js.map